import { safeDefine } from "../../registration/safe-define.js";
import { SliderPreviewElement } from "../../ui/slider/preview.js";
//#region src/define/ui/slider-preview.ts
safeDefine(SliderPreviewElement);
//#endregion
